<template>
  <div
    class="relative w-full h-full group overflow-hidden"
    @mouseenter="showControls = true"
    @mouseleave="showControls = false"
  >
    <!-- Slide wrapper -->
    <div
      class="flex transition-transform duration-700 ease-in-out"
      :style="{ transform: `translateX(-${currentSlide * 100}%)` }"
    >
      <div
        v-for="(slide, index) in slides"
        :key="index"
        class="w-full h-full shrink-0"
      >
        <SlideComponent :image="slide.image" :text="slide.text" />
      </div>
    </div>

    <!-- Arrows -->
    <button
      @click="prevSlide"
      class="absolute left-4 top-1/2 transform -translate-y-1/2 text-white text-3xl bg-black/40 p-2 rounded-full opacity-0 group-hover:opacity-100 transition"
    >
      ‹
    </button>
    <button
      @click="nextSlide"
      class="absolute right-4 top-1/2 transform -translate-y-1/2 text-white text-3xl bg-black/40 p-2 rounded-full opacity-0 group-hover:opacity-100 transition"
    >
      ›
    </button>

    <!-- Dots -->
    <div class="absolute bottom-4 left-1/2 transform -translate-x-1/2 flex gap-2">
      <button
        v-for="(slide, index) in slides"
        :key="'dot-' + index"
        @click="goToSlide(index)"
        class="w-3 h-3 rounded-full"
        :class="{
          'bg-white': currentSlide === index,
          'bg-gray-400': currentSlide !== index
        }"
      ></button>
    </div>
  </div>
</template>

<script>
import SlideComponent from './SlideComponent.vue'

export default {
  name: 'HomePageImageSlider',
  components: { SlideComponent },
  props: {
    slides: Array,
    interval: {
      type: Number,
      default: 10000
    }
  },
  data() {
    return {
      currentSlide: 0,
      slideInterval: null,
      showControls: false
    }
  },
  mounted() {
    this.startSlider()
  },
  beforeUnmount() {
    clearInterval(this.slideInterval)
  },
  methods: {
    startSlider() {
      this.slideInterval = setInterval(() => {
        this.nextSlide()
      }, this.interval)
    },
    nextSlide() {
      this.currentSlide = (this.currentSlide + 1) % this.slides.length
    },
    prevSlide() {
      this.currentSlide =
        (this.currentSlide - 1 + this.slides.length) % this.slides.length
    },
    goToSlide(index) {
      this.currentSlide = index
    },
    handleMouseEnter() {
      this.showControls = true
    },
    handleMouseLeave() {
      this.showControls = false
    }
  }
}
</script>
